<template>
  <div>
    <el-form
        ref="form"
        :model="form"
        label-width="100px"
    >
      <gj-area-title>基本信息</gj-area-title>
      <el-row>
        <el-col :span="8">
          <el-form-item
              label="发货国"
          >
            中国
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :rules="[
                $gjRequired('请选择目的国')
              ]"
              label="目的国"
              prop="arrivalCountryCode"
          >
            <gj-select
                :disabled="isMeaningful(item)"
                :options="countryOption"
                v-model="form.arrivalCountryCode"
                width="140px"
            ></gj-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :rules="[
                $gjRequired('请选择物流方式')
              ]"
              label="物流方式"
              prop="transportId"
          >
            <gj-select
                :disabled="isMeaningful(item)"
                :options="transportOption"
                v-model="form.transportId"
                width="140px"
            ></gj-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
              :rules="[
                $gjRequired('请选择预计出运日期')
              ]"
              label="预计出运日期"
              prop="expectShipDate"
          >
            <gj-date-picker
                v-model="form.expectShipDate"
                :disabled="isMeaningful(item) && item.status !== shipmentBillEnum.WAIT_SHIPPED"
                width="140px"></gj-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
              :rules="[
                $gjRequired('请选择预计到达日期')
              ]"
              label="预计到达日期"
              prop="expectArrivalDate"
          >
            <gj-date-picker
                v-model="form.expectArrivalDate"
                :disabled="isMeaningful(item) && item.status !== shipmentBillEnum.WAIT_SHIPPED"
                width="140px"></gj-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <div style="margin-bottom: 24px;">
        <el-form-item label="备注">
          <gj-input
              v-model="form.memo"
              @input="debounceUpdateMemo"
              width="86%"></gj-input>
        </el-form-item>
      </div>
      <gj-area-title>物流信息</gj-area-title>
      <div>
        <el-form-item label="物流跟踪号">
          <gj-input
              :disabled="isMeaningful(item) && item.status === shipmentBillEnum.ABOLISHED"
              v-model="form.trackings"
              @input="debounceUpdateTrackings"
              width="86%"></gj-input>
        </el-form-item>
      </div>
      <div style="margin-bottom: 24px;">
        <el-form-item label="备注">
          <gj-input
              @input="debounceUpdateLogisticsMemo"
              v-model="form.logisticsMemo"
              width="86%"></gj-input>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
  import {formRuleMixin, isMeaningfulMixin, responseMixin} from "../../../../../minxins";
  import {shipmentBillEnum} from "../../../logistics/shipment-bill/enum";
  import {countryOption} from "../../../../../utils/options";
  import {isMeaningful, isMeaningless} from "../../../../../utils/common";
  import {
    getTransportSelect,
    updateShipNoteLogisticsMemo,
    updateShipNoteMemo,
    updateShipNoteTrackings
  } from "../../../../../api/logistics";

  export default {
    name: "app-shipment-bill-header-info",
    mixins: [isMeaningfulMixin, formRuleMixin, responseMixin],
    props: {
      item: null,
      headerInfoData: null,
    },
    watch: {
      headerInfoData: {
        immediate: true,
        handler(value) {
          if (isMeaningful(value)) {
            this.form.arrivalCountryCode = value.arrivalCountryCode;
            this.form.transportId = value.transportId;
            this.form.expectShipDate = value.expectShipDate;
            this.form.expectArrivalDate = value.expectArrivalDate;
            this.form.memo = value.memo;

            this.form.trackings = value.trackings;
            this.form.logisticsMemo = value.logisticsMemo;
          }
        }
      }
    },
    created() {
      getTransportSelect()
        .then((data) => {
          this.transportOption = data.map(v => {return {id: v.id, text: v.name}})
        })
    },
    data() {
      return {
        shipmentBillEnum: shipmentBillEnum,
        // 与产品沟通,生成发货单时目的国移除GB英国,查看发货单详情时兼容原来选择GB英国的数据,不会导致展示异常,对数据源不做处理
        countryOption: isMeaningful(this.item) ? countryOption : countryOption.filter(item => item.id !== 'GB'),
        transportOption: [],
        form: {
          arrivalCountryCode: null,
          transportId: null,
          expectShipDate: null,
          expectArrivalDate: null,
          memo: null,

          trackings: null,
          logisticsMemo: null,
        },
        debounceUpdateMemo: this._.debounce(this.updateMemo, 500),
        debounceUpdateLogisticsMemo: this._.debounce(this.updateLogisticsMemo, 500),
        debounceUpdateTrackings: this._.debounce(this.updateTrackings, 500),
      }
    },
    methods: {
      updateMemo() {
        if (isMeaningless(this.item) || this.item.status === shipmentBillEnum.WAIT_SHIPPED) {
          return;
        }
        updateShipNoteMemo({id: this.item.id, memo: this.form.memo})
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('自动保存成功');
            })
          })
      },
      updateLogisticsMemo() {
        if (isMeaningless(this.item) || this.item.status === shipmentBillEnum.WAIT_SHIPPED) {
          return;
        }
        updateShipNoteLogisticsMemo({id: this.item.id, logisticsMemo: this.form.logisticsMemo})
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('自动保存成功');
            })
          })
      },
      updateTrackings() {
        if (isMeaningless(this.item) || this.item.status === shipmentBillEnum.WAIT_SHIPPED) {
          return;
        }
        updateShipNoteTrackings({id: this.item.id, trackings: this.form.trackings})
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('自动保存成功');
            })
          })
      }
    }
  }
</script>

<style scoped>
</style>
